import * as React from 'react';
import Popover from '@mui/material/Popover';
import { Avatar, Box, Divider, IconButton } from '@mui/material';
import CustomText from 'components/common/CustomText/CustomText';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { useMemo } from 'react';
import { getIsDoctor } from 'common/utils';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DashboardsAccordion from 'components/common/DashboardsAccordion/DashboardsAccordion';
import LogoutDialog from 'components/common/LogoutDialog/LogoutDialog';
import LogoutIcon from '@mui/icons-material/Logout';

interface Props {
  //   patientId: number;
}

export default function UserMenu({ }: Props) {
  const { user, doctor } = useAuth();
  const globalStyles = useGlobalStyles();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [logoutOpen, setLogoutOpen] = React.useState<boolean>(false);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };



  const isDoctor = useMemo(() => {
    return getIsDoctor(user?.user_role?.name);
  }, [user, doctor]);

  const avatar = useMemo(() => {
    return doctor ? doctor.user_media?.image?.href_small : user?.profile_image?.href_small;
  }, [user, doctor]);

  const username = useMemo(() => {
    return doctor ? `${isDoctor == true ? 'Dr. ' : ''}${doctor.name}` : `${isDoctor == true ? 'Dr. ' : ''}${user.last_name}, ${user.first_name}`
  }, [user, doctor]);

  const handleProfilePress = () => {
    handleClose();
    navigate('profile')
  }

  return (
    <div>

      {/* User menu */}
      <IconButton
        onClick={handleOpen}
        className={globalStyles.headerIconButton}
      >
        <Box
          display={'flex'}
          alignItems={'center'}
          gap={1}
        >
          <Avatar
            src={avatar}
            alt={'profile'}
            sx={{
              width: 16,
              height: 16,
              bgcolor: colors.avatarBg,
            }}
          />

          <CustomText text={username} fontSize={12} color={colors.primary} fontWeight={600} />

          <KeyboardArrowDownIcon
            fontSize="small"
            sx={{
              color: colors.primary,
              '&:hover': {
                color: colors.primary,
              },
            }}
          />
        </Box>
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '10px',
            overflow: 'hidden',
            width: '250px',
          }}
          p={1}
        >
          {!doctor && <IconButton
            onClick={handleProfilePress}
            className={globalStyles.popoverButtonContainer}
          >
            <Box className={globalStyles.popoverIconContainer}>
              <Avatar
                src={user?.profile_image?.href_small}
                alt={'profile'}
                sx={{
                  width: 18,
                  height: 18,
                  bgcolor: colors.avatarBg,
                }}
              />
            </Box>
            <CustomText text="Profile" ml="5px" color={colors.black} />
          </IconButton>}

          <Divider />

          <DashboardsAccordion onClose={handleClose}/>

          <Divider />

          <IconButton className={globalStyles.popoverButtonContainer} onClick={() => setLogoutOpen(true)}>
            <Box className={globalStyles.popoverIconContainer}>
              <LogoutIcon sx={{ color: colors.black, fontSize: 17 }} />
            </Box>
            <CustomText text="Logout" ml="5px" color={colors.black} />
          </IconButton>
        </Box>
      </Popover>

      <LogoutDialog
        open={logoutOpen}
        setOpen={setLogoutOpen}
      />
    </div>
  );
}
